import Config from "../config";
import { AxiosInstance } from "../helpers/AxiosInstance";
import { mapToPlanModel } from "../models/plan.model";

// export const getAllPlanDetails = async () => {
//     try {        
//         const res = await AxiosInstance.get(`${Config.API_URL}/api/v1/stripe/products`);
//         const planModels = res.data?.map(mapToPlanModel)
//         return planModels;
//     } catch (e) {
//         console.log(e);
//         return 400;
//     }
// };

export const getAllPlans = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/v1/stripe/products`);
}

export const getActivePlan = async () => {
    try {
        const res = await AxiosInstance.get(`${Config.API_URL}/api/v1/stripe/customer-active-subscription`);
        const plan = mapToPlanModel(res.data)
        return plan
    } catch (e) {
        return 400;
    }
}

export const ChangePlan = (data: {
    quantity: number,
    price_id: string
}) => {
    return AxiosInstance.post(`${Config.API_URL}/api/v1/stripe/customer-plan-session`, data);
}

export const BuyPlan = (data: {
    organization_id: string,
    product_id: string,
    quantity: number,
    price_id: string,
    mode: string
}) => {
    return AxiosInstance.post(`${Config.API_URL}/api/v1/stripe/create-checkout-session`, data);
}

export const cancelSubscription = () => {
    return AxiosInstance.post(`${Config.API_URL}/api/v1/stripe/customer-plan-session-cancel`);
}